// @packages
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// @scripts
import MasterPage from './MasterPageDisplay';
import { config } from '../../config';
import { globalUI } from '../../core';
import { collapseMainMenu, expandMainMenu } from '../../actions';

const MasterPageContainer = ({
    history,
    loadingPageIsVisible,
    loadingPageMsg,
    location,
    mainMenuIsExpanded,
    mainMenuOnCollapse,
    mainMenuOnExpand,
    modalDialogCancelLabel,
    modalDialogFormValid,
    modalDialogIsVisible,
    modalDialogMsg,
    modalDialogOkLabel,
    modalDialogOnConfirm,
    modalDialogShowCancel,
    modalDialogStyle,
    modalDialogTitle,
    modalDialogWidth,
    toastNotificationIsVisible,
    toastNotificationMsg,
    toastNotificationType,
    userLanguageCode
}) => {
    config.applyLanguage(userLanguageCode);
    globalUI.setBrowserHistory(history);

    const currentUrl = location.pathname;
    const route = config.routes.find((route) => route.url === currentUrl);
    const pageTitle = route ? config.text.routes[route.name] : null;

    return (
        <MasterPage
            appName={config.text.appName}
            currentUrl={currentUrl}
            loadingPageProps={{
                isVisible: loadingPageIsVisible,
                msg: loadingPageMsg
            }}
            mainMenuProps={{
                isExpanded: mainMenuIsExpanded,
                onCollapse: mainMenuOnCollapse,
                onExpand: mainMenuOnExpand
            }}
            modalDialogProps={{
                cancelLabel: modalDialogCancelLabel,
                formValid: modalDialogFormValid,
                isVisible: modalDialogIsVisible,
                msg: modalDialogMsg,
                okLabel: modalDialogOkLabel,
                onConfirm: modalDialogOnConfirm,
                onHide: globalUI.hideModalDialog,
                showCancel: modalDialogShowCancel,
                style: modalDialogStyle,
                title: modalDialogTitle,
                width: modalDialogWidth
            }}
            pageTitle={pageTitle}
            toastNotificationProps={{
                isVisible: toastNotificationIsVisible,
                msg: toastNotificationMsg,
                onHide: globalUI.hideToastNotification,
                type: toastNotificationType
            }}
        />
    );
};

MasterPageContainer.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.object.isRequired,
        push: PropTypes.func.isRequired
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
    }).isRequired,
    loadingPageIsVisible: PropTypes.bool.isRequired,
    loadingPageMsg: PropTypes.string,
    mainMenuIsExpanded: PropTypes.bool.isRequired,
    mainMenuOnCollapse: PropTypes.func.isRequired,
    mainMenuOnExpand: PropTypes.func.isRequired,
    modalDialogCancelLabel: PropTypes.string,
    modalDialogFormValid: PropTypes.bool,
    modalDialogIsVisible: PropTypes.bool.isRequired,
    modalDialogMsg: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    modalDialogOkLabel: PropTypes.string,
    modalDialogOnConfirm: PropTypes.func,
    modalDialogShowCancel: PropTypes.bool,
    modalDialogStyle: PropTypes.object,
    modalDialogTitle: PropTypes.string,
    modalDialogWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    toastNotificationIsVisible: PropTypes.bool.isRequired,
    toastNotificationMsg: PropTypes.string,
    toastNotificationType: PropTypes.string,
    userLanguageCode: PropTypes.string
};

MasterPageContainer.defaultProps = {
    loadingPageMsg: null,
    modalDialogCancelLabel: null,
    modalDialogFormValid: null,
    modalDialogMsg: null,
    modalDialogOkLabel: null,
    modalDialogOnConfirm: null,
    modalDialogShowCancel: true,
    modalDialogStyle: null,
    modalDialogTitle: null,
    modalDialogWidth: null,
    toastNotificationMsg: null,
    toastNotificationType: null,
    userLanguageCode: 'en'
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    mainMenuOnCollapse: collapseMainMenu,
    mainMenuOnExpand: expandMainMenu
}, dispatch);

const mapStateToProps = ({
    loadingPage,
    mainMenu,
    modalDialog,
    toastNotification
}) => ({
    loadingPageIsVisible: loadingPage.isVisible,
    loadingPageMsg: loadingPage.msg,
    mainMenuIsExpanded: mainMenu.isExpanded,
    modalDialogCancelLabel: modalDialog.cancelLabel,
    modalDialogFormValid: modalDialog.formValid,
    modalDialogIsVisible: modalDialog.isVisible,
    modalDialogMsg: modalDialog.msg,
    modalDialogOkLabel: modalDialog.okLabel,
    modalDialogOnConfirm: modalDialog.onConfirm,
    modalDialogShowCancel: modalDialog.showCancel,
    modalDialogStyle: modalDialog.style,
    modalDialogTitle: modalDialog.title,
    modalDialogWidth: modalDialog.width,
    toastNotificationIsVisible: toastNotification.isVisible,
    toastNotificationMsg: toastNotification.msg,
    toastNotificationType: toastNotification.type
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(MasterPageContainer);
